import {
  isNil,
  isNaN,
  isArrayLike,
  isObject,
  size,
} from 'lodash';

export default (value) => {
  if (isNil(value) || isNaN(value)) {
    return true;
  } else if (isArrayLike(value)) {
    return value.length === 0;
  } else if (isObject(value)) {
    return size(value) === 0;
  }
  return false;
};
